export { default } from './footer';
export { footerHandler } from './footer.handler';
export { footerQuery } from './footer.query';
export { footerLocaleConfig, LocaleSelectorLabel } from './footer.utils';
